<template>
  <v-app
    id="modal-open-link-tab"
    style="z-index: 1041; position: absolute"
    data-vuetify
    v-if="openLinkModal"
  >
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="openLinkModal"
      style="z-index: 1041; position: absolute"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          >Link bloqueado</v-toolbar
        >
        <v-card-text class="mt-2">
          <p>
            <strong>{{ text }}</strong>
          </p>
          <p class="mt-2">
            <a
              :href="url"
              target="_blank"
              >{{ urlText }}</a
            >
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="openLinkModal = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import {
  VApp,
  VCard,
  VToolbar,
  VDialog,
  VCardTitle,
  VBtn,
  VCardText,
  VCardActions,
  VListItemGroup,
  VSpacer,
  VDivider,
} from "vuetify/lib";

export default {
  props: ["data"],

  components: {
    VApp,
    VCard,
    VToolbar,
    VDialog,
    VCardTitle,
    VBtn,
    VCardText,
    VCardActions,
    VListItemGroup,
    VSpacer,
    VDivider,
  },

  computed: {
    openModal() {
      return this.data.open;
    },
  },

  data() {
    return {
      url: "",
      openLinkModal: false,
      text: "",
      urlText: "Clique aqui para abrir novamente.",
      url: "",
    };
  },

  created() {},

  methods: {
    openTabLink() {
      var newWin;
      try {
        newWin = window.open(this.url);
      } catch (error) {}

      if (!newWin || newWin.closed || typeof newWin.closed == "undefined") {
        this.openLinkModal = true;
      }
    },
  },

  watch: {
    data: {
      handler(val) {
        this.url = val.url;
        this.text = val.text;
        this.urlText = val.urlText;
        this.openTabLink();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
#modal-open-link-tab {
  height: 0px;
}
</style>
